import api from "./api";

const dashboard = {
	get() {
		return api.get('ipv/dashboard')
	},
};

export default dashboard